import React, {useEffect} from 'react';
import { getFailingSubscriptions } from '../../slices/dashboard';
import { useSelector, useDispatch } from 'react-redux'
import { Card } from '.';

export const FailingSubscribersCard = () => {

    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getFailingSubscriptions())
    }, [])

    const failingSubscriptions = useSelector((state) => state.dashboard.failingSubscriptions?.failing_subscriptions);

    return (
        Card({backgroundColor: 'purple', fontColor: 'white', heading: 'Failing Subscribers', number: failingSubscriptions})
    );
};